import { render } from "./Booking_TourGuide.vue?vue&type=template&id=159c845b&scoped=true"
import script from "./Booking_TourGuide.vue?vue&type=script&lang=js"
export * from "./Booking_TourGuide.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-159c845b"

export default script